<template>
  <button
    type="button"
    class="csat-input-card"
    :class="{ 'csat-input-card--selected': selected }"
    @click="$emit('update', CSAT_DISPLAY_TYPES.STAR)"
  >
    <svg
      v-for="n in 5"
      :key="n"
      class="csat-input-card__icon"
      viewBox="0 0 24 24"
      width="24"
      height="24"
    >
      <path
        d="M12 2 14.9 8.6 22 9.3 16.5 14.1 18.2 21 12 17.3 5.8 21 7.5 14.1 2 9.3 9.1 8.6Z"
      />
    </svg>
  </button>
</template>

<script>
import { CSAT_DISPLAY_TYPES } from 'shared/constants/messages';

export default {
  name: 'CSATStarInput',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CSAT_DISPLAY_TYPES,
    };
  },
};
</script>

<style scoped lang="scss">
.csat-input-card {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: var(--space-smaller);
  padding: var(--space-normal);

  &--selected {
    border-color: var(--w-500);
  }

  &__icon {
    fill: var(--amber-500);
    height: 24px;
    width: 24px;
  }
}
</style>
